<div echarts [options]="options" [merge]="updateOptions"></div>